import { GenIcon } from './iconBase';

export function PiXCircleFill(props: any) {
  return GenIcon({
    tag: 'svg',
    attr: { viewBox: '0 0 256 256', fill: 'currentColor' },
    child: [
      {
        tag: 'path',
        attr: {
          d: 'M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm37.66,130.34a8,8,0,0,1-11.32,11.32L128,139.31l-26.34,26.35a8,8,0,0,1-11.32-11.32L116.69,128,90.34,101.66a8,8,0,0,1,11.32-11.32L128,116.69l26.34-26.35a8,8,0,0,1,11.32,11.32L139.31,128Z',
        },
        child: [],
      },
    ],
  })(props);
}
